export const isTruckParking = (parking) => parking.onlyTrucksAllowed
